import { TKeys } from './types'

export const es_es: Record<TKeys, string> = {
    ...require('./en-en').en_en, // TODO
    // SCREENS
    // General
    loading: 'Cargando...',
    // SignIn
    signin_title: 'Registrese',
    signin_redirect_title: 'Verificar su nombre de usuario y contraseña',
    psw_placeholder_redirect: "Confirmar contraseña",
    psw_placeholder: 'Introducir contraseña',
    email_placeholder: 'Dirección electronica',
    language: 'Idioma',
    forgot_password: '¿Contraseña olvidad?',
    signup_hint: '¿No tiene cuenta? Registrese',
    btn_signin: 'Registrese',
    // Intro
    // N-Ary sort
    my_profile: 'Mis preferencias',
    btn_submit: 'Enviar',
    btn_finish: 'Terminar',
    hint_undo: '¿Está usted seguro de que desea revocar su última acción?',
    // Global screen
    tip_quit: '¿Está usted seguro de que desea abandonar esto?',
    // State screen // Tell us, what is your ideal work environment?
    intro_title: 'La felicidad es la clave del éxito',
    intro_body: `Si usted ama lo que hace y al equipo con el que trabaja, alcanzará el éxito en su vida profesional.`,
    howto1_title: `Verá 2 declaraciones
    
    Seleccione la que prefiera

    Sólo le llevará 12 minutos`,
    howto1_body: `Es necesario realizar esta prueba en un ambiente pacífico.`,
    award1_title: '¡Felicidades!',
    award1_body: `En la parte superior de la siguiente pantalla encontrarás lo que consideras más importante en tu entorno de trabajo ideal.  Si lo desea, puede reorganizar el orden de las afirmaciones arrastrándolas y soltándolas.`,
    award2_title: '¡Ya has recorrido más de la mitad del camino!',
    award2_body: `Imersión en la emoción de descubrir tu entorno laboral ideal. Las declaraciones más relevantes se encuentran al principio de esta lista. Experimenta la emoción de reorganizarlos según tus preferencias arrastrándolos y soltándolos. El espacio de trabajo de tus sueños está a tu alcance`,
    award3_title: 'Felicitaciones por la tercera parte',
    award3_body: `¡Ya está cerca de alcanzar el objetivo! La línea de meta está a la vista. Respira hondo, dalo todo en estos últimos momentos y celebra el increíble logro que te espera. ¡Lo has conseguido! Termina con fuerza y deja que se desarrolle la historia de tu éxito.`,
    howto2_title: 'Y ahora las últimas preguntas - ±2 minutos',
    howto2_body: `Se le harán algunas preguntas más. Todavía tiene que ordenar algunas afirmaciones, de la más importante (arriba) a la menos importante (abajo)`,
    title_rank: 'En mi entorno de trabajo **IDEAL**',
    subtitle_rank_2: 'lo más importante es ...',
    subtitle_rank_n: '¿Dónde situaría la siguiente afirmación?',
    hint_reorder: 'Reordenar según sea necesario, de más a menos importante',
    hint_overview: 'Presione el botón para visualizar el resumen.',
    hint_profile: 'Mis Preferencias Actuales',
    hint_place_below: 'Coloque la siguiente declaración',
    title_rank_bucket: 'Últimas comparaciones',
    subtitle_rank_best: 'This time, which one is the MOST important to you?',
    subtitle_rank_least: 'Which one is the LEAST important to you?',
    subtitle_rank_reorder: 'Reordenar de MÁS a MENOS importante',
    title_thanks: '¡Felicidades!',
    hint_thanks: 'Sus preferencias se han enviado correctamente',
    title_error: 'No podemos enviar sus datos',
    hint_error: 'Por favor, inténtelo más tarde ...',
    hint_error_validation: 'Ocurrió un error de validación, por favor inténtalo de nuevo más tarde',
    hint_error_dup: 'Ya ha presentado un informe anterior.',
    hint_confirm_round: '¿Seguro que quiere confirmar esta clasificación?',
    retry_btn: 'Reintentar',
    btn_to_overview: 'VISTA GENERAL',
    btn_to_bucket_x: 'CANASTA',
    btn_to_params: 'PARAMS',
    btn_open: 'ABRIR',
    btn_start: 'INICIAR',
    btn_confirm: 'CONFIRMAR',
    // btn_next: 'NEXT',
    btn_next: '>',
    btn_next_str: 'SIGUIENTE',
    btn_next_round: 'SIGUIENTE RONDA',
    // btn_prev: 'PREV',
    btn_prev: '<',
    btn_cancel: 'CANCELAR',
    // btn_back: 'BACK',
    btn_back: '<',
    btn_download: 'Descargar su informe',
    btn_quit: 'SALIR',
    // Comparisons
    pick_best: '¿Cuál es el más importante para usted?',
    pick_worst: '¿Cuál es el menos importante para usted?',
    vs: 'O',
    // UI elements
    round: 'Ronda',
    stm: 'Declaración',
    bucket: 'Canasta',
    axis_y: 'Número de Declaraciones',
    tip_saved: 'Guardado',
    top_scale_hint: 'Lo **MÁS** importante',
    bottom_scale_hint: 'Lo **MENOS** importante',
    pick_tip: '¡Seleccionado!',
    how_to_binary_title: 'Instrucciones',
    // values
    samen: 'Collaboración',
    conf: 'Conformidad',
    erken: 'Reconocimiento',
    zorg: 'Atención',
    gelijk: 'Igualdad y diversidad',
    zelfsturing: 'Autonomia',
    macht: 'Poder',
    voorspelbaar: 'Previsibilidad',
    prestatie: 'Rendimiento',
    zelfontplooi: 'Desarrollo personal',
    duurzaam: 'Sostenibilidad',
    integriteit: 'Integridad',
    innovatie: 'Innovación',
    daadkracht: 'Fortaleza',
    // 
    no_slug_error: 'Por favor, asegúrese de que siguió el enlace correcto. Si lo hizo, comuníquese con el administrador/servicio de soporte',
    unknown_error: 'Ocurrió un error desconocido, por favor inténtalo de nuevo más tarde',
    invalid_credentials: 'Combinación de correo electrónico y contraseña inválida',
    // 360
    // TLTM scale
    lvl0: 'Por favor, selecciona',
    lvl1: 'Extremadamente poco',
    lvl2: 'Muy Poco',
    lvl3: 'Poco',
    lvl4: 'Justo',
    lvl5: 'Mucho',
    lvl6: 'Demasiado',
    lvl7: 'Excesivamente demasiado',
    lvlx1: '-3',
    lvlx2: '-2',
    lvlx3: '-1',
    lvlx4: 'Justo',
    lvlx5: '+1',
    lvlx6: '+2',
    lvlx7: '+3',
    // SCALE 10 lvlSC10x
    lvlSC10x00: 'Por favor, selecciona',
    lvlSC10x00e: '🤔',
    //
    lvlSC10x0e: '😫',
    lvlSC10x0nps: 'Nunca',
    lvlSC10x0: 'None',
    lvlSC10x1e: '😖',
    lvlSC10x1nps: 'MISSING',
    lvlSC10x1: 'Extremadamente malo',
    lvlSC10x2e: '😣',
    lvlSC10x2nps: 'MISSING',
    lvlSC10x2: 'Muy malo',
    lvlSC10x3e: '😠',
    lvlSC10x3nps: 'MISSING',
    lvlSC10x3: 'Insuficiente',
    lvlSC10x4e: '🙁',
    lvlSC10x4nps: 'MISSING',
    lvlSC10x4: 'Malo',
    lvlSC10x5e: '😯',
    lvlSC10x5nps: 'MISSING',
    lvlSC10x5: 'Mediocre',
    lvlSC10x6e: '😐',
    lvlSC10x6nps: 'MISSING',
    lvlSC10x6: 'Promedio',
    lvlSC10x7e: '🙂',
    lvlSC10x7nps: 'MISSING',
    lvlSC10x7: 'Bueno',
    lvlSC10x8e: '😊',
    lvlSC10x8nps: 'MISSING',
    lvlSC10x8: 'Muy bueno',
    lvlSC10x9e: '😃',
    lvlSC10x9nps: 'MISSING',
    lvlSC10x9: 'Excelente',
    lvlSC10x10e: '😍',
    lvlSC10x10nps: 'Ciertamente',
    lvlSC10x10: 'Impecable',
    howto_360_title: `Como organización, nosotras otorgamos una gran importancia a los valores, creemos que es esencial saber qué es lo que realmente te hace feliz en tu entorno laboral.`,
    howto_360_body: `Este cuestionario es y seguirá siendo anónimo para tu jerarquía, que solo recibirá los resultados agregados`,
    picker_360_title_workenv: "En mi entorno laboral actual …",
    picker_360_title_leadership: "Mi gerente directo …",
    nps_title: "¿Recomendarías a alguien que conoces trabajar aquí?",
    comment_title: 'Agregar un comentario',
    comment_placeholder: 'Agradezco todos sus comentarios constructivos',
    comment_save: 'Guardar y cerrar',
    comment_remaining: 'character(s) left',
    howto_workenv_title: 'And now, your work environment',
    howto_workenv_body: 'What about it ? Last questions, we promise!',
    howto_nps_title: "",
    howto_nps_body: "",
    // legacy_v2:
    btn_next_step: 'Siguiente',
    to_assign: 'Por asignar',
    least_important: 'Menos importante',
    moderately_important: 'Moderadamente importante',
    most_important: 'Más importante',
    ranker_title: '¿Qué es importante en tu trabajo ideal?',
    too_insufficient_warning: 'Este grupo contiene declaraciones insuficientes',
    too_much_warning: 'Este grupo contiene demasiadas declaraciones',
    too_much_warning1: 'Has asignado demasiadas declaraciones a los siguientes grupo(s):',
    too_much_warning2: 'Haz clic en el grupo y reasigna las declaraciones a otro grupo hasta que la distribución sea correcta',
    empty_bin: 'Este grupo está vacío',
    //    further_ranking: '¿Qué es importante en tu trabajo ideal?',
    further_ranking: 'Por favor, clasifica aún más las {{v1}} declaraciones que marcaste como "{{v2}}"',
    hint_modal_title: 'Imagina tu entorno laboral ideal',
    hint_modal_body1: 'Clasifica 42 declaraciones sobre tu entorno ideal de menos a más importante',
    hint_modal_body2_left: 'izquierda',
    hint_modal_body2_left_txt: 'las 11 declaraciones que consideras menos importantes',
    hint_modal_body2_right: 'derecha',
    hint_modal_body2_right_txt: 'las 11 declaraciones que consideras más importantes',
    hint_modal_body2_middle: 'centro',
    hint_modal_body2_middle_txt: 'las 20 declaraciones que consideras moderadamente importantes',
    hint_modal_body3: 'Arrastra y suelta cada declaración en el grupo que mejor se ajuste a ti',
    hint_modal_cta: 'Iniciar',
    hint_top: 'Desplazarse hacia arriba',
    hint_down: 'Desplazarse hacia abajo',
    final_distribution_invalid_title: 'La distribución final no es válida',
    final_distribution_invalid_body: 'Hay {{v1}} cubo(s) con demasiadas declaraciones y {{v2}} cubo(s) con muy pocas declaraciones',
    no_available_bins_warning: 'No hay cubos disponibles para la asignación aleatoria - todos los cubos están en su capacidad máxima',
    sort_middle_bucket_title: '¿Le gustaría ordenar el cubo del medio?',
    sort_middle_bucket_body: 'Esto ordenará el cubo del medio por valor.',
    reflect_current_view_title: '¿Refleja esto su vista actual?',
    reflect_current_view_sort_body: 'Si no, se le ofrecerá ordenar su clasificación final',
    yes: 'Sí',
    no: 'No',
    final_ranking: 'Clasificación final',
    example: 'Ejemplo :',
}